import { GOOGLE } from '@rsos/constants/mapProviders';
import { getRSOSMap } from '@rsos/utils/rsosGlobal';
import type { MapViewState } from './mapViewState.types';

/** Current Google map view state. Deliberately free of any ArcGIS import. */
export const getGoogleMapViewState = (
  esriBasemap = '',
): MapViewState | null => {
  const rsosMap = getRSOSMap();

  if (rsosMap?.mapProvider !== GOOGLE) {
    return null;
  }

  const map = rsosMap.mapInstance;
  const bounds = map.getBounds();
  const center = map.getCenter();

  if (!bounds || !center) {
    return null;
  }

  const northEast = bounds.getNorthEast();
  const southWest = bounds.getSouthWest();

  return {
    bounds: {
      north: northEast.lat(),
      east: northEast.lng(),
      south: southWest.lat(),
      west: southWest.lng(),
    },
    // NOTE: x is inverted (xmin from NE, xmax from SW). Pre-existing; kept so
    // this stays a bundle change. Fixing it needs its own commit and test,
    // alongside the useEsriMapTransition read that consumes it.
    extent: {
      xmin: northEast.lng(),
      ymin: southWest.lat(),
      xmax: southWest.lng(),
      ymax: northEast.lat(),
    },
    esriBasemap,
    latitude: center.lat(),
    longitude: center.lng(),
    provider: GOOGLE,
    width: map.getDiv().offsetWidth,
    height: map.getDiv().offsetHeight,
    zoom: map.getZoom() || null,
  };
};
